import { render } from "./MarathonsContent.vue?vue&type=template&id=06a821c3"
import script from "./MarathonsContent.vue?vue&type=script&lang=js"
export * from "./MarathonsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__